import { useEffect } from "react";
import { PaywallAuthErrorCodes, SiteLinks, PremiumPaywallSignModes, SignInType } from "../../../../../global/paywall/paywallInterfaces";
import { PremiumPaywallState } from "../premiumPaywallDesktop";
interface PremiumPaywallDesktopSigninEmailProps {
  emailOrPhone: string
  setEmailOrPhone: (emailOrPhone: string) => void
  setMode: (state: PremiumPaywallState) => void
  loginWithGoogle: () => void
  loginWithApple: () => void
  sendMail: () => void
  authError: string
  isNewspaper?: boolean;
  setAuthError?: (error: PaywallAuthErrorCodes) => void;
  setSignInType?: (type: SignInType) => void;
  signInType?: SignInType;
}


interface PremiumPaywallSigninEmailNewspaperProps extends PremiumPaywallDesktopSigninEmailProps {

  handleMailChange: (e: any) => void;
  handleSendMail: () => void;
  isMobile?: boolean;
  contactUrl: string;
  handleEmailReset: () => void;
}

declare const window: Window & {
  PAYWALL_SITE_LINKS: SiteLinks;
  ENABLE_SIGNIN_VIA_SMS: boolean;
}
const contactUrl = typeof window !== "undefined" && window.PAYWALL_SITE_LINKS ? window.PAYWALL_SITE_LINKS.contact : '';
const isSmsSignInEnabled = typeof window !== "undefined" && window.ENABLE_SIGNIN_VIA_SMS;


const errorMessage: Partial<Record<PaywallAuthErrorCodes, string>> = {
  [PaywallAuthErrorCodes.INVALID_EMAIL]: 'כתובת דוא"ל אינה תקינה',
  [PaywallAuthErrorCodes.INVALID_CELL_PHONE_NUMBER]: 'מספר טלפון אינו תקין',
  [PaywallAuthErrorCodes.FAILED_TO_SEND_OTP]: "אירעה שגיאה במערכת, אנא נסו שוב מאוחר יותר",
  [PaywallAuthErrorCodes.NOT_REGISTERED]: 'פרטי ההתחברות שהוזנו אינם נכונים',
  [PaywallAuthErrorCodes.NOT_REGISTERED_PHONE]: `פרטי ההתחברות שהוזנו אינם נכונים, ניתן לעדכן באזור האישי לאחר התחברות או לפנות ל<a href="${contactUrl}" className="contact-link">שירות הלקוחות</a>`,
  [PaywallAuthErrorCodes.OTP_MAX_ATTEMPTS]: "חרגת ממספר בקשות אימות. יש לפנות לשירות לקוחות",
  [PaywallAuthErrorCodes.NON_UNIQUE_PHONE_NUMBER]: `מספר הטלפון שייך ליותר מחשבון אחד. אנא הזדהה באמצעות כתובת דוא"ל`,
  [PaywallAuthErrorCodes.PHONE_NUMBER_NOT_NUMERIC]: `יש להקליד מספרים בלבד`
}

export const PremiumPaywallDesktopSigninEmail = (props: PremiumPaywallDesktopSigninEmailProps) => {
  const { emailOrPhone, setEmailOrPhone, loginWithApple, loginWithGoogle, setMode, sendMail, authError, isNewspaper, setAuthError, signInType, setSignInType } = props
  const handleMailChange = (e) => {
    if (signInType === SignInType.otpPhone) {
      const phoneRegex = /^\d+$/;
      if (e.target.value && !phoneRegex.test(e.target.value)) {
        setAuthError(PaywallAuthErrorCodes.PHONE_NUMBER_NOT_NUMERIC);
        return;
      }
    }
    if (e.target.value.length === 0 && authError) {
      setAuthError(null);
    }
    setEmailOrPhone(e.target.value)
  }

  const handleSignInType = (e) => {
    const newSignInType = e.target.value as SignInType;
    setSignInType(newSignInType);
    handleEmailReset();
  }

  const handleSendMail = () => {
    sendMail();
    const accountSendMailAnalytics = new CustomEvent("accountSendMailAnalytics", { detail: { label: "signin" } })
    document.dispatchEvent(accountSendMailAnalytics);
  }
  const loginEvent = (mode) => {
    setMode({ mode: mode })
    const loginButtonEvent = new CustomEvent("loginButtonEvent", { detail: { mode: mode } })
    document.dispatchEvent(loginButtonEvent);
  }
  const handleNewspaperRegister = (mode: PremiumPaywallSignModes) => {
    setMode({ mode: mode, isNewspaper: true })
    const newspaperRegisterEvent = new CustomEvent("handleNewspaperRegister")
    document.dispatchEvent(newspaperRegisterEvent);
  }
  const loginWithThirdPartyEvent = (type: string) => {
    type === "google" ? loginWithGoogle() : loginWithApple();
    const handleThirdPartyLogin = new CustomEvent("handleThirdPartyLogin", { detail: { loginMethod: type, type: "signin" } })
    document.dispatchEvent(handleThirdPartyLogin);
  }
  const handlePressKey = (e) => {
    if (e.key === 'Enter') {
      handleSendMail();
    }
  }

  const handleEmailReset = () => {
    setEmailOrPhone('');
    setAuthError(null);
  }

  if (isNewspaper) {
    return <PremiumPaywallSigninEmailNewspaper {...props} handleEmailReset={handleEmailReset} contactUrl={contactUrl} handleSendMail={handleSendMail} handleMailChange={handleMailChange} />
  } else {
    return (
      <div className="premium-paywall-desktop-signin-email">
        <h1 className="title">כניסה</h1>
        {isSmsSignInEnabled && <div className="radio-buttons-container">
          <label className="radio-option">
            <input
              type="radio"
              name="signin-type"
              value={SignInType.otpEmail}
              checked={signInType === SignInType.otpEmail}
              onChange={handleSignInType}
            />
            <span className="radio-text">באמצעות דוא"ל</span>
          </label>
          <label className="radio-option">
            <input
              type="radio"
              name="signin-type"
              value={SignInType.otpPhone}
              checked={signInType === SignInType.otpPhone}
              onChange={handleSignInType}
            />
            <span className="radio-text">באמצעות מס' טלפון נייד</span>
          </label>
        </div>}
        <div className={`email-signin ${authError ? 'error' : ''}`}>
          <input onKeyDown={handlePressKey} value={emailOrPhone} onChange={handleMailChange} type="email" placeholder={isSmsSignInEnabled ? 'הקלידו כאן...' : 'הקלידו כתובת דוא"ל'} />
          {emailOrPhone && <div className="reset-icon" onClick={handleEmailReset}></div>}
          <p
            className="error-text"
            dangerouslySetInnerHTML={{ __html: errorMessage[authError] }}
          />
        </div>
        <div className="buttons-container">
          <button disabled={!emailOrPhone.length} className="button-base continue" onClick={handleSendMail}>המשך</button>
        </div>
        <div className="separator">
          <div className="line" />
          <span className="text">או באמצעות</span>
          <div className="line" />
        </div>
        <div className="social-signin">
          <button className="social-button google-btn" onClick={() => loginWithThirdPartyEvent('google')}><span>גוגל</span></button>
          <button className="social-button apple-btn" onClick={() => loginWithThirdPartyEvent('apple')}><span>אפל</span></button>
        </div>
        <div className="login">
          <div>לא מנויים? <button type="button" onClick={() => loginEvent('signUp')}>לרכישת מינוי</button></div>
        </div>
        <div className="newspaper-users" >
          <div><span>מנויים לעיתון</span> <span className="yedioth-label"></span></div>
          <div onClick={() => handleNewspaperRegister('signIn')} className="newspaper-register-text">צרו חשבון ל-<div className="yedioth-plus-label"></div>ללא עלות</div>
        </div>
      </div>
    )
  }
}


export const PremiumPaywallSigninEmailNewspaper = (props: PremiumPaywallSigninEmailNewspaperProps) => {
  const { emailOrPhone, setEmailOrPhone, authError, handleMailChange, handleSendMail, isMobile, contactUrl, handleEmailReset } = props;

  const handlePressKey = (e) => {
    if (e.key === 'Enter') {
      handleSendMail();
    }
  }

  useEffect(() => {
    if (/^\d+$/.test(emailOrPhone)) {
        handleEmailReset();
    }
  }, []);

  return (
    <div className={`premium-paywall-${isMobile ? 'mobile' : 'desktop'}-signin-email newspaper`}>
      <div className="title-container"><span> כניסה למנויי </span><span className="yedioth-label-newspaper-mode"></span></div>
      <div className={`email-signin ${authError && authError.includes('EMAIL') ? 'error' : ''}`}>
        <input onKeyPress={handlePressKey} value={emailOrPhone} onChange={handleMailChange} type="email" placeholder='הקלידו כתובת דוא"ל' />
        {emailOrPhone && <div className="reset-icon" onClick={handleEmailReset}></div>}
        <p
          className="error-text"
          dangerouslySetInnerHTML={{ __html: errorMessage[authError] }}
        />
      </div>
      <div className="buttons-container">
        <button disabled={!emailOrPhone.length} className="button-base continue" onClick={handleSendMail}>המשך</button>
      </div>
      <div className="login">
        <div>לא זוכרים עם איזו כתובת דוא"ל נרשמתם? <a target="_blank" href={contactUrl}>צרו איתנו קשר</a></div>
      </div>
    </div>
  )

}